import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { DealBankJourneyStore } from '@features/dashboard/commercial/pages/deal-detail/components/bank-journey/deal-bank-journey.store';

/** As duas visões do cabeçalho do deal. */
export type DealJourneyView = 'deal' | 'banks';

/**
 * Seletor **Jornada do deal | Jornada nos bancos** no cabeçalho da tela do deal (card 3752, opção A do protótipo
 * "Deal do parceiro: foco na jornada do banco", escolhida pelo Breno em 27/10/2026).
 *
 * - Aparece sempre. Sem negociação do pipe de crédito ligada ao deal (`DealBankJourneyStore.unlocked`), o lado
 *   "Jornada nos bancos" fica travado, com cadeado e o aviso no hover.
 * - Enquanto a jornada carrega, o lado dos bancos fica desabilitado **sem** cadeado, para não piscar "travado" num
 *   deal que tem bancos.
 * - Quem troca a visão é a tela (`journeyChange`): a visão dos bancos é a aba `banks` da URL, então link antigo
 *   com `?tab=banks` continua abrindo direto nela.
 */
@Component({
  selector: 'app-deal-journey-switch',
  standalone: true,
  imports: [TooltipModule],
  templateUrl: './deal-journey-switch.component.html',
  styleUrl: './deal-journey-switch.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DealJourneySwitchComponent {
  protected readonly store = inject(DealBankJourneyStore);

  /** A visão dos bancos está aberta. */
  readonly banksActive = input(false);
  /** Texto do lado esquerdo: "Jornada do deal" na tela do deal, "Jornada dos deals" no Meus deals (card 3765). */
  readonly dealLabel = input('Jornada do deal');
  /** Aviso do cadeado, quando não há banco ligado. */
  readonly lockedTooltip = input(
    'Esta visão é liberada quando uma operação for vinculada a este deal.'
  );
  readonly journeyChange = output<DealJourneyView>();

  protected readonly locked = computed(() => this.store.loaded() && !this.store.unlocked());
  protected readonly banksDisabled = computed(() => !this.store.unlocked());

  protected select(view: DealJourneyView): void {
    if (view === 'banks' && this.banksDisabled()) return;
    if ((view === 'banks') === this.banksActive()) return;
    this.journeyChange.emit(view);
  }
}
